const multipleValidations = (value, validations) => {
  const checks = validations.map(validation => validation(value))
  const failedChecks = checks.filter(check => !!check)

  return failedChecks.length === 0 ? undefined : failedChecks.join(", ")
}

export const required = value => !value || value === "" ? 'Required' : undefined
export const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined
export const maxLength15 = maxLength(15)
export const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined
export const minLength2 = minLength(2)
export const number = value =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined
export const minValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined
export const minValue18 = minValue(18)
export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined
export const tooOld = value =>
  value && value > 65 ? 'You might be too old for this' : undefined
export const aol = value =>
  value && /.+@aol\.com/.test(value)
    ? 'Really? You still use AOL for your email?'
    : undefined
export const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined
export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined

export const ratioFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d+\/\d+$/i.test(value) ? 'Must be entered as number/number like 2/3' : undefined
  ])
)

export const baseballAverageFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d?\.\d{3}$/i.test(value) ? 'Must be entered like .250 or 1.000' : undefined
  ])
)

export const ERAFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d+\.\d{2}$/i.test(value) ? 'Must be entered like 2.25' : undefined
  ])
)

export const inningsPitchedFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d( [12]\/3)?$/i.test(value) ? 'Must be entered like 5 or 5 1/3 or 5 2/3' : undefined
  ])
)

export const distanceMetersFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d+m$/i.test(value) ? 'Must be entered in meters like 5000m' : undefined
  ])
)

export const finishTimeFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d{2}:\d{2}\.\d{2}$/i.test(value) ? 'Must be entered in minutes, seconds, and hundredths of a second like 00:00.00' : undefined
  ])
)

export const percentageFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d{2,3}\.\d{2}$/i.test(value) ? 'Must be entered like 100.00 or 50.25' : undefined
  ])
)

export const fieldGoalDistancesFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d+(, \d+)*$/i.test(value) ? 'Must be a comma-separated list of distances like 45 or 25, 45, 30' : undefined
  ])
)

export const penaltyTimeFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d{2}:\d{2}$/i.test(value) ? 'Must be entered in minutes and seconds like 02:00' : undefined
  ])
)

export const setScoreFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d:\d$/i.test(value) ? 'Must be entered like 2:1' : undefined
  ])
)

export const feetAndInchesFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d+' \d{1,2}( \d\/\d)?"$/i.test(value) ? 'Must be entered in feet and inched like 5\' 2" or 5\' 2 1/4"' : undefined
  ])
)

export const volleyballPlayedAndStartedFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^\d+-\d+-\d+$/i.test(value) ? 'Must be entered like 3-1-1' : undefined
  ])
)

export const winLossFormat = (value) => (
  multipleValidations(value, [
    required,
    (value) => !/^[01]\/[01]$/i.test(value) ? 'Must be entered as 1/0 or 0/1' : undefined
  ])
)

export const isHudlOrYouTubeURL = (value) => {
  if (value.includes('youtu')) {
    if (
      value.includes('watch?v=') ||
      value.includes('youtu.be/')
    ) {
      return undefined
    }
  } else if (value.includes('hudl')) {
    if (
      value.includes('hudl.com/embed/video/') ||
      value.includes('hudl.com/video/')
    ) {
      return undefined
    }
  } else {
    return 'Please enter a valid YouTube or Hudl video URL.'
  }
}



// WEBPACK FOOTER //
// ./src/utils/formValidators.js